export const MANUSCRIPT_COMPILER_OPTIONS = [
    { value: "pdflatex", label: "pdfLaTeX" },
    { value: "xelatex", label: "XeLaTeX" },
    { value: "lualatex", label: "LuaLaTeX" },
];

export const MANUSCRIPT_DEFAULT_COMPILER = "pdflatex";

export function getManuscriptCompilerLabel(value) {
    return MANUSCRIPT_COMPILER_OPTIONS.find((option) => option.value === value)?.label || value || "-";
}
